import { fromStoreByIdQueryToStore } from "../../../../../adapters/v3/pages/BookAppointment/adapters/from-store-by-id-query-to-store.js";
import { GET_BOOK_APPOINTMENT_STORE_BY_ID } from "../../../../../queries/v3/pages/BookAppointment/queries/get-book-appointment-store-by-id.js";
const getBookAppointmentStore = async (apolloClient, globalStoreId, locale, isTryInStoreFlowEnabled, isGroupIdEnabled) => {
  if (globalStoreId === void 0) {
    return null;
  }
  try {
    const { data, error } = await apolloClient.query({
      query: GET_BOOK_APPOINTMENT_STORE_BY_ID,
      variables: {
        globalStoreId
      },
      ...locale ? {
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        }
      } : {}
    });
    const storeQueryData = data?.store;
    const storeData = fromStoreByIdQueryToStore(storeQueryData, [
      { tryInStore: isTryInStoreFlowEnabled, groupId: isGroupIdEnabled }
    ]);
    if (error) {
      console.error(error);
    }
    return storeData;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export {
  getBookAppointmentStore
};
//# sourceMappingURL=book-appointment-store-by-id.js.map
